// --------------------------------------------------------------------------
// Contains the main components of the application and defines the routes and
// the general structure of the application.
// The code in App.js creates a component. In React, a component is a piece of
// reusable code that represents a part of a user interface. Components are
// used to render, manage, and update the UI elements in your application.
// --------------------------------------------------------------------------

import React from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, ProtectedRoute } from './context/security';
import { CPTProvider } from './context/cpt_context';
import { EOxProvider } from './context/eox_context';
import LandingPage from "./views/landing";
import AuthPage from "./views/auth";
import MainPage from "./views/main";
import CPTPage from "./views/cpt";
import EOxPage from "./views/eox";
import SatDBPage from "./views/satellite_db";
const App: React.FC = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/main" element={<ProtectedRoute><MainPage /></ProtectedRoute>} />
          <Route path="/cpt" element={<ProtectedRoute><CPTProvider><CPTPage /></CPTProvider></ProtectedRoute>} />
          <Route path="/eox" element={<ProtectedRoute><EOxProvider><EOxPage /></EOxProvider></ProtectedRoute>} />
          <Route path="/satellite-db" element={<ProtectedRoute><SatDBPage /></ProtectedRoute>} />
          {/* Add more routes as needed. Protect them if authentication is required. */}
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;